import React, { FC, useState, useEffect, ChangeEvent, MutableRefObject, useRef, useCallback } from 'react';
import { CommodityMilestone } from '@bechtel/types';
import { useSideSheetState } from '@bechtel/gds';
import { BacklogHeader } from './header';
import { BacklogSearchDrawer } from './backlog-drawer';
import {
  useSessionStorage,
  CacheKeys,
  usePlanning,
  UnassignedForemanId,
  AllForemanId,
  useConfig,
} from '@bechtel/client-common';
import { BacklogList } from './backlog-list';
import { BacklogFilter } from './types';
import { BackLogContainerStyled } from '../../styled';
import { MilestoneIdentifier } from '../../types';
import { defaultValues } from './types';

interface BacklogProps {
  setSelectedMilestoneDraggableIds: (value: string[] | []) => void;
  selectedMilestoneDraggableIds: string[];
  draggingMilestoneId: string;
  unplanMilestones: () => void;
  milestoneIdentifiers: MutableRefObject<Map<string, MilestoneIdentifier>>;
  backlogMilestoneData: MutableRefObject<CommodityMilestone[]>;
}

export const Backlog: FC<BacklogProps> = ({
  setSelectedMilestoneDraggableIds,
  selectedMilestoneDraggableIds,
  draggingMilestoneId,
  unplanMilestones,
  milestoneIdentifiers,
  backlogMilestoneData,
}) => {
  const { numPlanningNextWeeks } = useConfig();
  const { isReplan, selectedWpList, selectedForeman } = usePlanning();
  const { visible, open, close } = useSideSheetState(false);
  const [searchVal, setSearchVal] = useState<string>();
  const persistedDrawerValues = useRef(defaultValues);
  const [formData, setFormData] = useSessionStorage<BacklogFilter>(
    CacheKeys.BacklogFilter,
    persistedDrawerValues.current || defaultValues
  );

  const onBacklogFilterSubmit = useCallback(
    (values: BacklogFilter) => {
      setFormData(() => {
        persistedDrawerValues.current = values;
        return values;
      });
    },
    [setFormData]
  );

  const onSearch = (e: ChangeEvent<HTMLInputElement>) => {
    setSearchVal(e.target.value);
  };

  useEffect(() => {
    if (isReplan) {
      onBacklogFilterSubmit({ ...defaultValues, expiredMilestoneFilter: true });
    }
  }, [isReplan]);

  return (
    <>
      {visible && (
        <BacklogSearchDrawer close={close} onBacklogFilterSubmit={onBacklogFilterSubmit} initialValues={formData} />
      )}
      <BackLogContainerStyled
        isDrawerOpen={visible}
        style={numPlanningNextWeeks == 3 ? { width: '21%' } : { width: '25%' }}
      >
        <BacklogHeader
          open={open}
          onChange={onSearch}
          filterValues={formData}
          selectedMilestoneDraggableIds={selectedMilestoneDraggableIds}
          unplanMilestones={unplanMilestones}
        />
        {selectedWpList &&
          selectedWpList.length > 0 &&
          selectedForeman &&
          selectedForeman?.id !== AllForemanId &&
          selectedForeman?.id !== UnassignedForemanId && (
            <BacklogList
              setSelectedMilestoneDraggableIds={setSelectedMilestoneDraggableIds}
              selectedMilestoneDraggableIds={selectedMilestoneDraggableIds}
              draggingMilestoneId={draggingMilestoneId}
              searchVal={searchVal}
              formData={formData}
              milestoneIdentifiers={milestoneIdentifiers}
              backlogMilestoneData={backlogMilestoneData}
            />
          )}
      </BackLogContainerStyled>
    </>
  );
};
